module.exports = __webpack_public_path__ + "img/mfd_in_1_con2.c9db15c1.png";